import {config} from '../config';

export default {
    getAgeGateMinAge: () => config.data.login.ageGateMinAge,
    getLoginEmailRegex: () => config.data.login.loginEmailRegex,
    getLoginForgotPasswordUrl: () => config.data.login.loginForgotPasswordUrl,
    getLoginPasswordRegex: () => config.data.login.loginPasswordRegex,
    getLoginRegisterUrl: () => config.data.login.loginRegisterUrl,
    getPrivacyNoticeUrl: () => config.data.login.privacyNoticeUrl,
};
